import styled from 'styled-components/macro';
import { variables } from 'theme/variables';

const { custom_white: customWhite } = variables;

// specific for V2
export const ImageWrapperContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => (props.thumbnail || props.pointer ? 'pointer' : 'auto')};
  background: ${customWhite};
  .lg-react-element {
    display: flex;
    flex-wrap: wrap;
    max-width: 600px;
  }
  @media (max-width: 1820px) {
    width: ${(props) => (props.isDashboard ? '900px' : '600px')};
  }
  @media (max-width: 1687px) {
    width: ${(props) => (props.isDashboard ? '800px' : null)};
  }
  @media (max-width: 1479px) {
    width: ${(props) => (props.isDashboard ? '600px' : null)};
  }
  @media (max-width: 1300px) {
    width: ${(props) => (props.isDashboard ? '500px' : null)};
  }
  @media (max-width: 1200px) {
    width: ${(props) => (props.isDashboard ? '460px' : null)};
  }
  @media (max-width: 1130px) {
    width: ${(props) => (props.isDashboard ? '400px' : null)};
  }
  @media (max-width: 1080px) {
    width: ${(props) => (props.isDashboard ? '370px' : null)};
  }
  @media (max-width: 912px) {
    width: ${(props) => (props.isDashboard ? '300px' : null)};
  }
  @media (max-width: 840px) {
    width: ${(props) => (props.isDashboard ? '260px' : null)};
  }
  @media (max-width: 768px) {
    width: 500px;
  }
  @media (max-width: 580px) {
    width: 430px;
  }
  @media (max-width: 500px) {
    width: 100%;
    min-width: 200px;
  }
`;

export default ImageWrapperContainer;
